export const RoseAIContent = [
  {
    icon: "clock-stopwatch.svg",
    title: "Save Time",
    text: "Foster innovation by sharing workspaces, allowing team contributions while maintaining data integrity and security.",
  },
  {
    icon: "users-02.svg",
    title: "Collaborate",
    text: "Dive deep into your data stories with Rose AI's robust analysis tools and over 100 built-in data transformations.",
  },
  {
    icon: "bank-note-01.svg",
    title: "Cost Effective",
    text: "Effortlessly find the data you need with Rose AI's advanced search capabilities, powered by NLP and open-source llms.",
  },
  {
    icon: "check-verified-03.svg",
    title: "Expert Partnership",
    text: "Connect effortlessly to a wide range of data sources, ensuring you always have access to the data you need.",
  },
  {
    icon: "bezier-curve-01.svg",
    title: "Bespoke Datasets",
    text: "Get datasets precisely curated to meet your unique needs, enhancing your data-driven decisions.",
  },
  {
    icon: "coins-swap-02.svg",
    title: "Monetize your Data",
    text: "With Rose AI's secure marketplace, you can monetize your data assets, opening up new avenues for revenue.",
  },
];
